<script>
    import NavigateTooltip from "./Elements/NavigateTooltip.svelte";
    import {mainTimeline} from "../timelines/main-timeline";
    import {onMount} from "svelte";

    onMount(() => {
        mainTimeline.to('.box-tooltip', {opacity: 0, duration: 1}, 'gnosis0');
    });

</script>


<g class="box-tooltip">
    <NavigateTooltip text="Dive deeper"/>
</g>

<style>
    .box-tooltip {
        transform: translate(1170px, -125px) scale(1.5);
    }
</style>